import React, { useEffect, useState } from 'react';


const New2 = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  return (
   <div className='bg-white '>
     <div className='px-4 md:px-40 pt-3'>
      <h1 className="text-[14px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">NEWS</h1>
      <h1 className="text-[15px] md:text-[32px] font-bold mb-4 text-black">Agri-Tech , The future of Agriculture.</h1>

      <div className="relative w-full  overflow-hidden  rounded-lg bg-white">
        <div className="relative w-full rounded-lg">
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
              <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-[#742B3E] border-solid"></div>
            </div>
          )}
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744560909/image-2_pokima.png"
            alt="Securing Agriculture in Namibia"
            className={`w-full md:h-[622px] object-cover   rounded-lg transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
            onLoad={() => setIsLoading(false)}
          />
          
        </div>
      </div>

     
    <div className='px-1'>
      {/* Content Section */}
      <div className="mt-5 max-w-screen-xl w-full">
        <h3 className="text-black font-normal text-[14px] md:text-[30px]">March 03, 2025</h3>
        <div className="flex items-center gap-6 md:gap-8 text-[13px] md:text-[30px] font-normal text-black">
          <p>Story by Editorial team</p>
          <div className="flex items-center gap-2 text-[#155528]">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
              alt="Clock"
              className="h-6 w-6 md:h-8 md:w-8"
            />
            <p>2 Minutes read</p>
          </div>
        </div>
      </div>

    
      {/* Main Text Section */}
      <div className="mt-5 space-y-10">
  <p className="text-[10px] md:text-[32px] text-black font-normal">
    <strong>Sheep Farming in Namibia</strong><br/>
    <span className="md:mt-4 mt-2">
      Sheep farming is a significant component of Namibia's agricultural sector, contributing to the country's economy and food security. The industry has experienced various challenges and transformations over the decades, notably influenced by climatic conditions and market dynamics.
    </span>
  </p>

  <p className="text-[10px] md:text-[32px] text-black font-normal">
    <strong>Historical Context and Sheep Breeds</strong><br/>
    <span className="md:mt-6 mt-2">
      In the early 20th century, the Karakul sheep, later renamed Swakara, was central to Namibia's sheep farming. Renowned for its unique pelts, the Swakara industry flourished until the 1980s when global market shifts led to a decline. Currently, Swakara sheep constitute about 10% of the national sheep stock. <br/><br/>
      Today, the predominant sheep breeds in Namibia are those suited for mutton production, with the Dorper breed being particularly prevalent. The Damara sheep, native to Namibia, are also significant, especially in the northern regions. These breeds are valued for their adaptability to Namibia's arid conditions and their meat quality.
    </span>
  </p>

  <p className="text-[10px] md:text-[32px] text-black font-normal md:mb-6">
    <strong>Production Challenges and Climate Impact</strong><br/>
    <span>
      Sheep farming in Namibia faces challenges, notably droughts that have led to reduced grazing and forced many farmers to downsize their herds. Between 2013 and 2021, drought-induced destocking significantly lowered sheep numbers. However, with improved rainfall since early 2021, farmers are gradually rebuilding their flocks.
    </span>
  </p>

  <p className="text-[10px] md:text-[32px] text-black font-normal md:mb-6">
    <strong>Market Trends and Export Dynamics</strong><br/>
    <span>
      In 2022, sheep marketing in Namibia increased by 39%, reaching 565,894 head compared to 406,005 in 2021. Live sheep exports saw a 49% rise, totaling 424,807 in 2022. South Africa remains the primary destination for Namibian sheep exports. Sheep farming in Namibia faces challenges, notably droughts that have led to reduced grazing and forced many farmers to downsize their herds. Between 2013 and 2021, drought-induced destocking significantly lowered sheep numbers. However, with improved rainfall since early 2021, farmers are gradually rebuilding their flocks.
    </span>
  </p>

  <p className="text-[10px] md:text-[32px] text-black font-normal md:mb-6">
    <strong>Regenerative Practices and Sustainability</strong><br/>
    <span>
      To combat environmental challenges, some Namibian farmers are adopting regenerative agriculture practices. These methods aim to restore soil health and enhance livestock resilience, offering a sustainable path forward for sheep farming in the region.
    </span>
  </p>

  <p className="text-[10px] md:text-[32px] text-black font-normal md:mb-6">
    <span>
      Sheep farming in Namibia is a dynamic sector influenced by historical developments, climatic conditions, and evolving market demands. <strong>Embracing sustainable farming practices and adapting to environmental challenges are crucial for the industry's future viability and growth.</strong>
    </span>
  </p>

  <div className='md:h-10 h-4'></div>
</div>

    </div>

    </div>
   </div>
  );
};

export default New2;
